// Package Imports
import React, { useEffect, useMemo } from 'react';
import { Card, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import debounce from 'lodash/debounce';
// Project Imports
import scrollToTop from 'core/utils/scrollToTop';
import WorkflowStatusTable from 'pages/workflow/WorkflowStatusTable';

interface WorkflowStatusViewUIProps {
  tableProps: any;
  headers: any[];
  loading: boolean;
  onSearchChange: (value: string) => void;
  activeSearch: string;
}

const WorkflowStatusViewUI = ({
  tableProps,
  headers,
  loading,
  onSearchChange,
  activeSearch,
}: WorkflowStatusViewUIProps) => {
  useEffect(() => {
    scrollToTop();
  }, []);

  // Debounce so we don't fire a request on every keystroke, but still search
  // live as the user types (no Enter / search-button click required).
  const debouncedSearch = useMemo(
    () => debounce((value: string) => onSearchChange(value), 300),
    [onSearchChange]
  );

  useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

  return (
    <Card>
      <div className="task-list overflow-hidden">
        {/* Search bar — only filter available for this view */}
        <div className="flex items-center justify-between mb-md">
          <h2 className="text-base font-medium m-0">Workflow Status</h2>
          <Input
            placeholder="Search by Name or Code"
            allowClear
            defaultValue={activeSearch}
            onChange={(e) => debouncedSearch(e.target.value)}
            style={{ width: 280 }}
            prefix={<SearchOutlined className="text-neutral-90" />}
          />
        </div>

        <WorkflowStatusTable
          tableProps={tableProps}
          headers={headers}
          loading={loading}
        />
      </div>
    </Card>
  );
};

export default WorkflowStatusViewUI;
